import { KoAPI } from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const ClientsAPI = {
  getClients(query) {
    return KoAPI.get(`/api/${version}/admin/customer`, { query: { ...query } });
  },
  getGroupByClients(query) {
    return KoAPI.get(`/api/${version}/admin/customer/grouped`, { query: { ...query } });
  },
  getOnTrackTotalCount() {
    return KoAPI.get(`/api/${version}/admin/dashboard/ontrack`);
  },
  getCustomerGrowth() {
    return KoAPI.get(`/api/${version}/admin/dashboard/customerflow`);
  },
  createOrUpdateClient(data, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/admin/customer/${id}`, { data });
    } else {
      return KoAPI.post(`/api/${version}/admin/customer`, { data });
    }

  },
  getSupportTickets(id) {
    return KoAPI.get(`/api/${version}/admin/customer/linked/${id}`);
  },
  linkWorkspace(data, query) {
    return KoAPI.update(`/api/${version}/admin/customer/bulkupdate`, { data, query: { ...query } });
  },
  getWorkspaceList() {
    return KoAPI.get(`/api/${version}/workspace`);
  },
  getClientById(id) {
    return KoAPI.get(`/api/${version}/admin/customer/${id}`);
  },
  deleteById(id) {
    return KoAPI.delete(`/api/${version}/admin/customer/${id}`);
  },
  deleteBulkCustomers(data) {
    return KoAPI.post(`/api/${version}/admin/customer/bulkdelete`, { data });
  },
  getLoacations() {
    return KoAPI.get(`/api/${version}/admin/dashboard/location`);
  },
  getUsers() {
    return KoAPI.get(`/api/${version}/org/users`);
  },
  sendEmial(data) {
    return KoAPI.post(`/api/${version}/admin/customer/send/email`, { data });
  },
  getComments(customerId) {
    return KoAPI.get(`/api/${version}/customercomments/${customerId}`);
  },
  createComment(data, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/customer/comments/${data?.customerId}/${id}`, { data: { ...data } });
    } else {
      return KoAPI.post(`/api/${version}/customercomments`, { data: { ...data } });
    }
  },
  updateFileds(data, id) {
    return KoAPI.patch(`/api/${version}/admin/customer/update/fields/${id}`, { data: { ...data } });
  },
  deleteComment(customerId, commentId) {
    return KoAPI.delete(`/api/${version}/customercomments/${customerId}/${commentId}`);
  },
  createReaction(customerId, commentId, data) {
    return KoAPI.update(`/api/${version}/customercomments/reaction/${customerId}/${commentId}`, { data: { ...data } });
  },

  updateCustomerTypes(data, id) {
    return KoAPI.update(`/api/${version}/admin/customer/types`, { data });
  },
  updateCustomerWorkflow(data, id) {
    return KoAPI.update(`/api/${version}/admin/customer/workflow`, { data });
  },
  getCustomerTypes(data, id) {
    return KoAPI.get(`/api/${version}/admin/customer/list-types`);
  },
  getCustomerWorkflow(data, id) {
    return KoAPI.get(`/api/${version}/admin/customer/list-workflow`);
  },
  getTemplates(data, id) {
    return KoAPI.get(`/api/${version}/admin/all/templates`);
  },
  createOrUpdateTemplate(data, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/admin/template/${id}`, { data });
    } else {
      return KoAPI.post(`/api/${version}/admin/template`, { data });
    }
  },
  deleteTemplate(id) {
    return KoAPI.delete(`/api/${version}/admin/template/${id}`);
  },

  getTotalCount() {
    return KoAPI.get(`/api/${version}/admin/dashboard/count`);
  },

  getActiveCustomersCount() {
    return KoAPI.get(`/api/${version}/admin/dashboard/active`);
  },

  getWorkflowCount() {
    return KoAPI.get(`/api/${version}/admin/dashboard/workflow`);
  },

  getTypeCount() {
    return KoAPI.get(`/api/${version}/admin/dashboard/type`);
  },
  getallRatings(query) {
    return KoAPI.get(`/api/${version}/ratings`, { query: { ...query } });
  },
  deleteByIdRating(id) {
    return KoAPI.delete(`/api/${version}/ratings/${id}`);
  },
  getPayments(query) {
    return KoAPI.get(`/api/${version}/payment`, { query: { ...query } });
  },

  getRatingsSummary(){
    return KoAPI.get(`/api/${version}/ratings/summary/count`);
  },
  getEngagenementRating(){
    return KoAPI.get(`/api/${version}/ratings/engagement/monthly`);
  }
};